import { render, staticRenderFns } from "./studentHomework.vue?vue&type=template&id=03d71376&scoped=true&"
import script from "./studentHomework.vue?vue&type=script&lang=js&"
export * from "./studentHomework.vue?vue&type=script&lang=js&"
import style0 from "./studentHomework.vue?vue&type=style&index=0&id=03d71376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d71376",
  null
  
)

export default component.exports